import LocalizedStrings from 'react-localization';
 
let localized = new LocalizedStrings({
	 'en': {
	   noNearByStations: "Unfortunately no nearby stations could be found.",
	   noFavorites: "There are no stations in the favorites.",
	   noConnections: "Unfortunately no connections could be found for this station at the moment. Please try to select other stations in the vicinity.",
	   track: "Track",
	   cancelled: "Cancelled",
	   edit: "Edit",
	   done: "Done",
	   noLocationPermission: "Please allow location tracking to show stations in your vicinity.",
	   locationTimeout: "Your location could not be determined in time. Please try again or search for a station.",
	   locationUnavailable: "Your location is currently unavailable. Please check your device's location services or search for a station.",
	   nearbyTimeout: "Loading nearby stations took too long. Please try again.",
	   nearbyUnavailable: "Nearby stations could not be loaded. Please check your connection and try again.",
	   retry: "Try again",

	   apiError: "Something went wrong…",
	   apiLang: "en"
	 },
	 'de': {
	   noNearByStations: "Leider konnten keine Stationen in der Nähe gefunden werden.",
	   noFavorites: "In den Favoriten befinden sich keine Stationen.",
	   noConnections: "Leider können zur Zeit keine Verbindungen an dieser Station gefunden werden. Bitte versuche es mit Stationen in der Umgebung.",
	   track: "Gleis",
	   cancelled: "Ausgefallen",
	   edit: "Bearbeiten",
	   done: "Fertig",
	   noLocationPermission: "Bitte erlaube die Ortungsdienste, damit Stationen in deiner Nähe angezeigt werden können.", 
	   locationTimeout: "Dein Standort konnte nicht rechtzeitig ermittelt werden. Versuche es erneut oder suche nach einer Station.",
	   locationUnavailable: "Dein Standort ist derzeit nicht verfügbar. Prüfe die Ortungsdienste deines Geräts oder suche nach einer Station.",
	   nearbyTimeout: "Das Laden der Stationen dauert zu lange. Bitte versuche es erneut.",
	   nearbyUnavailable: "Die Stationen konnten nicht geladen werden. Prüfe deine Internetverbindung und versuche es erneut.",
	   retry: "Erneut versuchen",

	   apiError: "Etwas ist schief gelaufen…",
	   apiLang: "de"
	 }
});

export default localized;
